import { useSelector } from 'react-redux';
import '../../styles/components/footer/footer.scss';
import { RootState } from '../../store/store';

const Footer = () => {
  const merchantName = useSelector(
    (state: RootState) => state.user.merchant.config.merchant_name
  );
  const year = new Date().getFullYear();
  return (
    <div className='footer1'>
      <div className='footer1__content'>
        <h2>{`${merchantName} ${year}`} &#169;</h2>
      </div>
    </div>
  );
};

export default Footer;
